import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { setCookie, getCookie, deleteCookie, hasCookie } from "cookies-next";
import styles from "./AddToWishlist.module.scss";

import { addToWishlist } from "@/redux/actions/wishlistAction";
import { removeFromWishlist } from "@/redux/actions/wishlistAction";
import { openAccountSidebar,passMsgToAccountSidebar } from "@/redux/actions/loggedInUser";
import {
  addProductToWishlist,
  getCustomerId,
  removeProductFromWishlist,
  getWishlistProducts,
} from "@/helpers/wishlistHelpers";
import { getVariantPrice } from "@/helpers/pdpHelpers/priceHelpers";

import FavouriteIcon from "../FavouriteIcon";
import { addToWishlistTrack } from "../Tracking";
import { openMiniCart } from "@/redux/actions/addToCartAction";
import { errorMessages, generalConstants } from "@/utils/constants";
import { generateBadge } from "@/helpers/pdpHelpers/badgeHelpers";
import { getBaseColor, isBeautyOrJewelryPDP } from "@/helpers/generalHelper";

export default function AddToWishlist({
  selectedVariant,
  product,
  favouriteIconHeight,
  favouriteIconWidth,
  favouriteIconWrapperClass = styles.favourite_btn, // default
  isSizeSelected,
  isSizeDropdownOpen,
  setIsSizeDropdownOpen,
  setSelectedColor,
  setSelectedLetter,
  setSelectedSize,
  autoAdd,
  wishListCallBack,
  setFireWishList,
  autoRemove,
  hasClass,
  isPDP
}) {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.loginUser.userData?.id);
  const wishlistItems = useSelector((state) => state.wishlist.wishlist);
  const wishlistHash = useSelector((state) => state.wishlist.wishlistHashId);
  const isWishlistLoading = useSelector((state) => state.wishlist.loading_status);


  const [isFavourite, setIsFavourite] = useState(autoRemove ? true : false);
  const [isLoading, setIsLoading] = useState(false);
  const [toBeAddedToWishlist, setToBeAddedToWishlist] = useState(false);

  const defaultWishlistButtonText = isFavourite
  ? "Remove from wishlist"
  : "Add to wishlist";

  useEffect(() => {
    if (autoAdd) {
      /* Fire add to wishlist on comp load */
      handleFavouriteClick();
    }
  }, [autoAdd]);
  useEffect(() => {
    // Check if user is logged in before pre-filling heart icon
      if (wishlistItems) {
        // If product has multiple size, and size is not selected, do not prefill
        if (isSizeSelected) {
          //pre-filling heart icon
          let isPresentInWishlist = wishlistItems.some(
            (item) =>
              item?.ProductVariantId &&
              item.ProductVariantId == getCustomerId(selectedVariant.id)
          );
          setIsFavourite(isPresentInWishlist);
        }
      }
  }, [wishlistItems, selectedVariant.id, isSizeSelected]);

  const addItemToWishlist = async ({ hash, product, selectedVariant }) => {
    if (!isLoading) {
      setIsLoading(true);
      const encodedCustomerID = userId;

      // Convert product and variant ids from base64 encoded format to the number format that is expected by wishlist hero API
      const productIdNumber = getCustomerId(product.id);
      const productVariantIdNumber = getCustomerId(selectedVariant.id);

      const productPriceObj = getVariantPrice(
        selectedVariant,
        "regular",
        false
      );

      const formattedPriceObj = getVariantPrice(
        selectedVariant,
        "regular",
        true
      );

      // condition for identifying product type beauty or jewelry
      const isBeautyOrJewelryCategory = isBeautyOrJewelryPDP(product?.tags)

      // If product is beauty or jewelry, then get color from selected options, else get base color from variant basecolor
      const selectedColor =isBeautyOrJewelryCategory? selectedVariant.selectedOptions.find(
        (option) => option.name.toLowerCase() === "color"
      )?.value: getBaseColor(selectedVariant?.baseColor?.value);

      const selectedSize = selectedVariant.selectedOptions.find(
        (option) => option.name.toLowerCase() === "size" || option.name.toLowerCase() === "denominations"
      )?.value;

      const selectedLetter = selectedVariant.selectedOptions.find(
        (option) => option.name.toLowerCase() === "style"
      )?.value;

      const badge_curated = generateBadge(product.tags);  
      const availabilityType = product.tags?.includes(generalConstants.pre_order_tag) ?  generalConstants.pre_order : product.tags?.includes(generalConstants.available_now_tag) ? generalConstants.available_now : '';

      const newWishlistItem = {
        ProductId: productIdNumber,
        ProductVariantId: productVariantIdNumber,
        ProductName: product.title,
        ProductImage: selectedVariant?.image?.src ? selectedVariant.image.src : "no-image",
        ProductLink: process.env.NETLIFY_URL + "/products/" + product.handle,
        Price:
          productPriceObj.returnedSalePrice || productPriceObj.returnedPrice,
        FormattedPrice: formattedPriceObj.returnedPrice,
        FormattedSalePrice: formattedPriceObj.returnedSalePrice,
        Vendor: product.vendor,
        AvailableForSale: selectedVariant.availableForSale || selectedVariant.quantityAvailable ? true : false,
        Color: selectedColor,
        Size: selectedSize,
        Letter: selectedLetter,
        olivela_cost: selectedVariant.olivela_cost,
        barcode: selectedVariant.barcode,
        tags: product.tags, //tags required to show details on product tile
        badge_curated: badge_curated,
        availability: availabilityType,
      };

      let request = {
        ...newWishlistItem,
        // encodedCustomerID: encodedCustomerID,
        hash: hash,
        currentWishlistItems: wishlistItems,
      }; 
      
      let response = await addProductToWishlist(request);
      setIsLoading(false);
      if (response.ok) {
        sessionStorage.setItem("wishlist", JSON.stringify({ items: [...wishlistItems, newWishlistItem] }));
        // Update wishlist array in redux
        dispatch(addToWishlist(newWishlistItem));
      }
    }
  };

  // OS-938 -Given a customer is not signed in, when they have clicked on wishlist icon and then sign in, then the heart icon should be filled
  // isFavourite cookie is set true only when user interacts with account siderbar opened by on click wishlist icon at PLP/PDP
  // maxage for isFavourite cookie is set to 5 minutes
  // useEffect(() => {
  //   if (hasCookie("isFavourite")) {
  //     let cookie_data = JSON.parse(getCookie("isFavourite"));
  //     // Make sure that currently opened product is the same product set in cookie
  //     if (product.id === cookie_data.product.id) {
  //       if (cookie_data.value === true && userId && wishlistHash) {
  //         deleteCookie("isFavourite");
  //         //  OS-1226
  //         /* If a user that is not signed in selects a different color/letter and then clicks on the heart icon, 
  //         the user is prompted to sign in. Once the user signs in, then the color/letter for which they had clicked the heart icon will be selected.
  //         At this point, if there is a size dropdown, then size dropdown will be opened. Else the variant will be directly added to wishlist */
  //         const selectedColor = cookie_data.variant.selectedOptions.find(
  //           (option) => option.name.toLowerCase() === "color"
  //         )?.value;
  //         if (selectedColor) {
  //           setSelectedColor(selectedColor);
  //         }

  //         const selectedLetter = cookie_data.variant.selectedOptions.find(
  //           (option) => option.name.toLowerCase() === "style"
  //         )?.value;
  //         if (selectedLetter) {
  //           setSelectedLetter(selectedLetter);
  //         }

  //         if (cookie_data.isSizeSelected) {
  //           const selectedSize = cookie_data.variant.selectedOptions.find(
  //             (option) => option.name.toLowerCase() === "size" || option.name.toLowerCase() === "denominations"
  //           )?.value;
  //           if (selectedSize) {
  //             setSelectedSize(selectedSize);
  //           }
  //         } else {
  //           setIsSizeDropdownOpen(true);
  //         }

  //         setToBeAddedToWishlist(true);
  //       }
  //     } else {
  //       // Remove cookie if different product was selected
  //       deleteCookie("isFavourite");
  //     }
  //   }
  // }, [userId, wishlistHash, product.id]);

  // OS-1226 - If product has multiple sizes and user has not selected a size, then open the size dropdown. Once the user selects a size, then add that variant to wishlist
  useEffect(() => {
    if (wishlistHash) {
      if (toBeAddedToWishlist) {
        // Once size dropdown is closed, add the variant to wishlist
        if (!isSizeDropdownOpen) {
          if (isSizeSelected) {
            setToBeAddedToWishlist(false);
            addItemToWishlist({
              hash: wishlistHash,
              product: product,
              selectedVariant: selectedVariant,
            });
            addToWishlistTrack(product);
          }
          // If user closes the size dropdown without selecting a size
          else {
            setToBeAddedToWishlist(false);
          }
        }
      }
    }
  }, [
    isSizeSelected,
    toBeAddedToWishlist,
    wishlistHash,
    isSizeDropdownOpen,
    product,
    selectedVariant,
  ]);

//   It checks whether the price is listed as $0.
  const isZeroPrice = (()=> {
    const productPriceObj = getVariantPrice(
      selectedVariant,
      "regular",
      false
    );
    const priceToCheck = productPriceObj.returnedSalePrice || productPriceObj.returnedPrice;

      if(!priceToCheck || parseFloat(priceToCheck)===0){
        return true
      } 
      return false

  })();

  const handleFavouriteClick = async () => {
    if(isZeroPrice){
      return
    }
    //set isFavouritePdp cookie to true if wishlist is clicked from PDP
    // if(isPDP){
    //   setCookie("isFavouritePdp","true");
    // }
    // Add to wishlist
    if (!isFavourite) {
      // If userId is defined then user is logged in
      // if (userId) {
        // If product has multiple sizes, and size is not selected, then do not add to wishlist
        if (!isWishlistLoading) {
          if (isSizeSelected) {
            try{
              await addItemToWishlist({
                hash: wishlistHash,
                product: product,
                selectedVariant: selectedVariant,
              });  
            }
            catch(e){
              console.log(e);
            }
            setIsFavourite(true);
            addToWishlistTrack(product);
            if(wishListCallBack) {
              /* Callback after successful add to wishlist action  */
              wishListCallBack();
            }
          } else {
            // If product has multiple sizes, and size is not selected, then open size dropdown
            setToBeAddedToWishlist(true);
            if(setIsSizeDropdownOpen)
            setIsSizeDropdownOpen(true);
          }

        }
        else {
          // Queue to addToWishlist request so that product is added to wishlist after wishlist is loaded
          if (!isSizeSelected) {
            setIsSizeDropdownOpen(true);
          }
          setToBeAddedToWishlist(true);
          addToWishlistTrack(product);
        }
      // }
    }
    // Remove from wishlist
    else {
      if (!isLoading) {
        setIsLoading(true);
        const productVariantId = getCustomerId(selectedVariant.id);

        const response = await removeProductFromWishlist({
          hash: wishlistHash,
          productVariantId: productVariantId,
        });
        
        setIsLoading(false);
        if (response.ok && response.deleted) {
          const newWishlistArray = wishlistItems.filter(
            (item) => item.ProductVariantId !== productVariantId
          )
          sessionStorage.setItem("wishlist", JSON.stringify({ items: newWishlistArray }));
          dispatch(removeFromWishlist(productVariantId));
        }
        if (wishListCallBack) {
          /* Callback after successful add to wishlist action  */
          wishListCallBack();
        }
      }
    }
  };
 
  return (
    <>
      <div tabIndex={isZeroPrice? -1: 0} className={`fav-add-to-bag-ga auto-addWishlist-btn medium small ${isLoading ? "loading" : ""} ${isFavourite ? "wishlisted" : ""} ${favouriteIconWrapperClass}
      ${isZeroPrice ? "disabled" : ""}
      `} 
      
      onClick={handleFavouriteClick} >
        <FavouriteIcon
          isFilled={isFavourite}
          height={favouriteIconHeight}
          width={favouriteIconWidth}
          isAddtoBagWrapper={true}
        />
      </div>
    </>
  );
}